/** 表格自动滚动 */
export const tableAutoScroll = (table) => { 
    // 拿到表格中承载数据的div元素
    const divData = table.bodyWrapper;
    divData.onmouseover = function () {
      clearInterval(t);
    }; //鼠标移入，停止滚动
    divData.touchmove = function(){
        clearInterval(t);
    }; 
    addEventListener("touchend",(event => {
        clearInterval(t);
    }));
    /*divData.onmouseout = function () {
        start();
    };*/ //鼠标移出，继续滚动
    
    // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
    let t;
    start();
    function start() {
      // 数据少于表格高度停止滚动
      
      t = setInterval(() => {
        
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        divData.scrollTop += 1;
      // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
      if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) { 
        // 重置table距离顶部距离
        divData.scrollTop = 0;
        //滚动到底部后，也可以从下向上滚动
        //divData.scrollTop -= 1;
      } 
      }, 50);
    }
  }